<template>
  <div class="exp-communicate">
    <div class="top">
      <div class="top-title">
        <div
          v-for="item in topMenus"
          :key="item.id"
          :class="item.id === defaultTopSelect ? 'topActive' : ''"
          @click="topChange(item.id)"
        >
          <img
            :src="
              item.id === defaultTopSelect ? item.selectIconPath : item.iconPath
            "
          />
          {{ $t(item.value) }}
        </div>
      </div>
    </div>
    <discuss v-if="showChange" />
    <commonQ v-else />
  </div>
</template>

<script>
import discuss from './question/discuss.vue'
import commonQ from './question/commonQ.vue'

export default {
  name: 'exp-communicate',
  components: { discuss, commonQ },
  props: ['expId'],
  data() {
    return {
      defaultTopSelect: 1,
      showChange: true,
      topMenus: [
        {
          id: 1,
          iconPath: require('@/img/node.png'),
          selectIconPath: require('@/img/node_select.png'),
          value: 'lang.external.fzsy.content.home.问题交流',
        },
        {
          id: 2,
          iconPath: require('@/img/node.png'),
          selectIconPath: require('@/img/node_select.png'),
          value: 'lang.external.fzsy.content.home.常见问题',
        },
      ],
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    topChange(val) {
      this.defaultTopSelect = val
      switch (val) {
        case 1:
          this.showChange = true
          break
        case 2:
          this.showChange = false
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.exp-communicate {
  width: 100%;
  color: #666666;
  background-color: #edf2f6;
  border-radius: 5px;
}
.topActive {
  background-color: #0c5893;
  color: #fff;
}
.top-title {
  display: flex;
  align-items: center;
  color: #0c5893;
  font-weight: bold;
  img {
    height: 16px;
    margin-right: 10px;
  }
  div {
    height: 51px;
    flex: 1;
    box-sizing: border-box;
    padding-left: 20px;
    line-height: 51px;
    border-bottom: 1px solid #ccd4da;
    cursor: pointer;
  }
}
</style>